import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const Loader = () => <div className='player_loader'><AiOutlineLoading3Quarters /></div>;

export default Loader;
